<template>
  <b-container id="getting-started">
    <b-row>
      <b-col cols="10" align-self="center">
        <h3>Thanks for installing rmCloud!</h3>
        <div class="mt-3">
          You'll now see a link to the app in the main navigation:
        </div>
        <div class="mt-3">
          <img src="https://d4wcwl3bu5zft.cloudfront.net/rmcloud-button-location.png" width="500px"/>
        </div>
        <div class="mt-3">
          Or, in the newer navigation it will be in the top of the screen:
        </div>
        <div class="mt-3">
          <img src="https://d4wcwl3bu5zft.cloudfront.net/rmcloud-button-location-new.png" width="500px"/>
        </div>
        <div class="mt-3">
          For instructions on how to use rmCloud, <a target="_blank" href="https://purpledrapes.atlassian.net/wiki/spaces/RD/pages/86933579/Getting+started">check out the Getting started page</a>
        </div>
        <div class="mt-3">
          For a quick overview of using rmCloud, check out the video below:
        </div>
        <div class="mt-3">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/P94bDH38vhE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="mt-3">
          If you ever need help (feature requests, bugs, not sure how to do something),
          just click the "Get help" button in the bottom right corner of the main app:
        </div>
        <div class="my-3">
          <img src="https://d4wcwl3bu5zft.cloudfront.net/get-help-button.png"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    mixins: [utilsMixin],
    mounted () {
      this.backupResizeToParentInCaseAuthViewOneFails()
    }
  }
</script>

<style>
  #getting-started {
    padding-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// GettingStartedView.vue?65698fa2